<div class="header">
  <span class="welcome">welcome to iconfig dashboard</span>
</div>
<ng-container *appLoading="allProjects$ | withLoading | async as allProjects">
  @if (allProjects.length > 0) {
  <div class="subheader">
    <div class="subheader-main">
      <span class="subheader-title">my projects</span>
      <p class="subheader-description">These are the projects you are assigned to as member</p>
    </div>
    <div class="subheader-actions">
      <button class="iconf-btn-filled minh40 minw250" [routerLink]="newProjectDialogLink">create new project</button>
    </div>
  </div>
  <app-project-list [projects]="allProjects"> </app-project-list>
  } @if (allProjects.length == 0) {
  <app-placeholder
    [icon]="noProjectsIcon"
    title="No projects assigned"
    description="You have not been assigned or created a project. You can start creating a new project."
    buttonCaption="create new project"
    (buttonClick)="navigateToNewProjectForm()"
  >
  </app-placeholder>
  }
</ng-container>
